import {
  ChangeDetectionStrategy, Component, computed, DestroyRef, HostBinding, inject, OnInit, signal,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule, DisabledDirective, FroalaModule, IconModule, SafeUrlPipe,
} from '@hglobal/common';
import {
  UserOnboardingTaskDetails,
} from '@pt/models';
import { CoinComponent, ConfettiComponent } from '@pt/components';
import { ImageLoaderDirective } from '@pt/directives';
import { environment } from '@pt/environment';

import {
  OnboardingTaskDetailsApiMockService,
  OnboardingTaskDetailsService,
} from './api';
import {
  TASK_DETAILS_API, TaskDetailsBaseComponent,
} from '../abstructions/task-details-base.component';

export type DialogData = {
  task: UserOnboardingTaskDetails;
  mode: 'preview' | 'regular';
  userOnboardingId?: number;
};

const CompletedIconAnimation = trigger('completedIcon', [
  state('notCompleted', style({ opacity: 0, transform: 'rotate(-45deg) scale(2)' })),
  state('completed', style({ opacity: 1 })),
  transition('notCompleted => completed', animate('100ms')),
]);

@Component({
  imports: [
    TranslateModule,
    ButtonModule,
    IconModule,
    MatSlideToggleModule,
    FroalaModule,
    RouterLink,
    DisabledDirective,
    ReactiveFormsModule,
    SafeUrlPipe,
    ConfettiComponent,
    ImageLoaderDirective,
    CoinComponent,
  ],
  providers: [
    {
      provide: TASK_DETAILS_API,
      useClass: environment.useMocks
        ? OnboardingTaskDetailsApiMockService
        : OnboardingTaskDetailsService,
    },
  ],
  selector: 'pt-onboarding-task-details',
  templateUrl: './onboarding-task-details.component.html',
  styleUrls: ['./onboarding-task-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [CompletedIconAnimation],
})
export class OnboardingTaskDetailsComponent
  extends TaskDetailsBaseComponent<UserOnboardingTaskDetails> implements OnInit {
  @HostBinding('class.pt-onboarding-task-details_completed') get isTaskCompleted() {
    return this.isCompleted();
  }

  taskConfirmationType = computed(() => this.task().confirmation);

  // TODO: workaround for non working type narrowing
  //  when type of signal is discriminating union type
  //  https://github.com/angular/angular/issues/49161
  get taskGetter() {
    return this.task();
  }
}
